import { Injectable } from '@angular/core';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FundsTitleService {

  constructor(private http: HttpClient) { }


  GetRecord(Token: String): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/FundsTitle?token=" + Token).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }

  GetActiveList(Token: String): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/FundsTitle/GetActiveList?token=" + Token).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }

  AddEditFundsTitle(model: General_Interface, Token: String): Observable<General_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id: model.id,
      title: model.title,
      del: false,
      username: Token,
      subdate: null
    }


    return this.http.post(environment.BaseUrl + "Daro/FundsTitle/AddEdit", body, { headers }).pipe(
      map(data => {
        return data as General_Interface
      })
    )

  }



  DeleteFundsTitle(id: number, Token: String): Observable<General_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/FundsTitle/Delete?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as General_Interface
      })
    )

  }


  MinusFundsTitle(id: number, Token: String): Observable<General_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/FundsTitle/Minus?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as General_Interface
      })
    )

  }

}
